export default {
	setWiypCall: (storeObj: any, { familyComposition, packageCode, packageId, response }: { familyComposition: string, packageCode: string, packageId: string, response: any }) => {
		storeObj.commit("setWiypCall", { familyComposition, packageCode, packageId, response });
		window.dispatchEvent(new Event("refreshDataStoredOnWindow"))
	},
}

